<template lang="pug">
  v-expansion-panel-header.app-expansion-panel-header(
    v-bind="extendProps"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
// ВРЕМЕННОЕ РЕШЕНИЕ!
// В дальнейшем глобально стилизовать панели и избавиться от этих компонентов
export default {
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    extendProps() {
      return {
        ...this.$attrs,
        ...this.$props,
        class: this.classes,
      };
    },
    classes() {
      return {
        'app-expansion-panel-header--outlined': this.outlined,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.app-expansion-panel-header {
  border-radius: 16px;
  min-height: 60px !important;
  background-color: transparent !important;

  &--outlined {
    border: 1px solid #{$redesignPrimaryLighten};
  }

  &.v-expansion-panel-header--active {
    border: 1px solid #{$redesignPrimary};
  }

  &:before {
    box-shadow: none !important;
  }
}
</style>
